import { usePulseSettings } from '@pulse/react';
import { defaultLanguage } from 'constants/languages';
import { useEffect, useState } from 'react';

import { mappingPageData } from 'strapi/pageMapper';

import { JsonResponseModel, StrapiDataModel, StrapiResponseModel } from 'strapi/types';

function usePageData(locale: string, pageSlug: string, cmsData: StrapiResponseModel): any {
  const [pageData, setPageData] = useState<JsonResponseModel>();

  const getPulseConfigName = () => {
    const slugPart = pageSlug.replace(/\/+/g, '_');
    const localePart = locale && locale !== defaultLanguage ? `_${locale}` : '';
    const result = `app-shell${localePart}_${slugPart}`;

    return result;
  };

  const {
    settings: pulseSettings,
    error: pulseError,
    loading: pulseLoading,
  }: {
    settings: StrapiDataModel;
    error: boolean;
    loading: boolean;
  } = usePulseSettings({
    tag: getPulseConfigName(),
    name: getPulseConfigName(),
  });

  useEffect(() => {
    if (cmsData) {
      if (cmsData.data?.waitForPulse && pulseLoading) return;
      if (cmsData.data?.waitForPulse && !pulseLoading && pulseSettings && !pulseError) {
        const isProxy = (obj: any) =>
          obj && typeof obj === 'object' && obj !== null && Reflect.ownKeys(obj).length > 0;
        const plainObject = isProxy(pulseSettings)
          ? JSON.parse(JSON.stringify(pulseSettings))
          : pulseSettings;

        setPageData(mappingPageData(cmsData, plainObject?.data));
      } else {
        setPageData(mappingPageData(cmsData));
      }
    }
  }, [locale, cmsData, pulseLoading, pulseSettings, pulseError]);
  return pageData;
}

export default usePageData;
